// Estrutura do formulário para associação de cliente
export const associationFormStructure = [[{
  name: 'cliente',
  label: 'Selecione um cliente',
  component: 'SearchSelect',
  placeholder: 'Digite para buscar clientes...',
  colProps: {
    md: 12
  },
  required: true,
  minSearchLength: 2,
  maxResults: 10,
  validation: {
    required: 'Selecione um cliente'
  }
}], [{
  name: 'diasRecorrencia',
  label: 'Dias de Recorrência',
  placeholder: 'Ex: 7',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 6
  },
  min: '0'
}, {
  name: 'recorrenciaLigada',
  label: 'Ativar recorrência',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 6
  }
}], [{
  name: 'valorIndividualPallet',
  label: 'Valor Individual Pallet',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}, {
  name: 'valorEtiquetas',
  label: 'Valor Etiquetas',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}, {
  name: 'valorArmazenagem',
  label: 'Valor Armazenagem',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}], [{
  name: 'freetime',
  label: 'Freetime (dias)',
  placeholder: 'Ex: 3',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 6
  },
  min: '0'
}, {
  name: 'dataVigencia',
  label: 'Data de Vigência',
  placeholder: 'Selecione a data',
  component: 'DatePickers',
  colProps: {
    md: 6
  }
}]]; // Estrutura do formulário para edição de cliente (sem o campo de seleção)

export const editFormStructure = [[{
  name: 'diasRecorrencia',
  label: 'Dias de Recorrência',
  placeholder: 'Ex: 7',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 6
  },
  min: '0'
}, {
  name: 'recorrenciaLigada',
  label: 'Ativar recorrência',
  component: 'CheckBox',
  type: 'checkbox',
  colProps: {
    md: 6
  }
}], [{
  name: 'valorIndividualPallet',
  label: 'Valor Individual Pallet',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}, {
  name: 'valorEtiquetas',
  label: 'Valor Etiquetas',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}, {
  name: 'valorArmazenagem',
  label: 'Valor Armazenagem',
  placeholder: '0,00',
  component: 'CurrencyInput',
  colProps: {
    md: 4
  },
  step: '0.01',
  min: '0',
  max: '99999999.99'
}], [{
  name: 'freetime',
  label: 'Freetime (dias)',
  placeholder: 'Ex: 3',
  component: 'FormField',
  type: 'number',
  colProps: {
    md: 6
  },
  min: '0'
}, {
  name: 'dataVigencia',
  label: 'Data de Vigência',
  placeholder: 'Selecione a data',
  component: 'DatePickers',
  colProps: {
    md: 6
  }
}]]; // Seções do formulário de associação

export const associationFormSections = [{
  title: 'Seleção do Cliente',
  rows: [0] // Renderiza a linha 0

}, {
  title: 'Configurações de Recorrência',
  rows: [1] // Renderiza a linha 1

}, {
  title: 'Valores Comerciais',
  rows: [2] // Renderiza a linha 2

}, {
  title: 'Configurações Operacionais',
  rows: [3] // Renderiza a linha 3

}]; // Seções do formulário de edição

export const editFormSections = [{
  title: 'Configurações de Recorrência',
  rows: [0] // Renderiza a linha 0

}, {
  title: 'Valores Comerciais',
  rows: [1] // Renderiza a linha 1

}, {
  title: 'Configurações Operacionais',
  rows: [2] // Renderiza a linha 2

}]; // Função de validação do formulário

export const validateAssociationForm = values => {
  const errors = {}; // Validação do cliente (obrigatório apenas para associação)

  if (!values.cliente) {
    errors.cliente = 'Selecione um cliente';
  } // Validações monetárias


  if (values.valorIndividualPallet !== undefined && values.valorIndividualPallet !== '') {
    const valorPallet = parseFloat(values.valorIndividualPallet);

    if (isNaN(valorPallet)) {
      errors.valorIndividualPallet = 'Valor individual do pallet deve ser um número válido';
    } else if (valorPallet < 0) {
      errors.valorIndividualPallet = 'Valor individual do pallet deve ser positivo';
    } else if (valorPallet > 99999999.99) {
      errors.valorIndividualPallet = 'Valor individual do pallet não pode ser maior que 99.999.999,99';
    }
  }

  if (values.valorEtiquetas !== undefined && values.valorEtiquetas !== '') {
    const valorEtiquetas = parseFloat(values.valorEtiquetas);

    if (isNaN(valorEtiquetas)) {
      errors.valorEtiquetas = 'Valor das etiquetas deve ser um número válido';
    } else if (valorEtiquetas < 0) {
      errors.valorEtiquetas = 'Valor das etiquetas deve ser positivo';
    } else if (valorEtiquetas > 99999999.99) {
      errors.valorEtiquetas = 'Valor das etiquetas não pode ser maior que 99.999.999,99';
    }
  }

  if (values.valorArmazenagem !== undefined && values.valorArmazenagem !== '') {
    const valorArmazenagem = parseFloat(values.valorArmazenagem);

    if (isNaN(valorArmazenagem)) {
      errors.valorArmazenagem = 'Valor da armazenagem deve ser um número válido';
    } else if (valorArmazenagem < 0) {
      errors.valorArmazenagem = 'Valor da armazenagem deve ser positivo';
    } else if (valorArmazenagem > 99999999.99) {
      errors.valorArmazenagem = 'Valor da armazenagem não pode ser maior que 99.999.999,99';
    }
  } // Validação do freetime


  if (values.freetime !== undefined && values.freetime !== '') {
    const freetime = parseInt(values.freetime);

    if (isNaN(freetime)) {
      errors.freetime = 'Freetime deve ser um número inteiro válido';
    } else if (freetime < 0) {
      errors.freetime = 'Freetime deve ser positivo';
    }
  } // Validação dos dias de recorrência


  if (values.diasRecorrencia !== undefined && values.diasRecorrencia !== '') {
    const diasRecorrencia = parseInt(values.diasRecorrencia);

    if (isNaN(diasRecorrencia)) {
      errors.diasRecorrencia = 'Dias de recorrência deve ser um número inteiro válido';
    } else if (diasRecorrencia < 0) {
      errors.diasRecorrencia = 'Dias de recorrência deve ser positivo';
    }
  }

  return errors;
}; // Função de validação para edição (sem validação de cliente)

export const validateEditForm = values => {
  const errors = validateAssociationForm(values); // Remove validação de cliente para edição

  delete errors.cliente;
  return errors;
}; // Funções auxiliares para mapear dados

export const mapFormToCreateApi = values => {
  return {
    IdCliente: values.cliente?.value || values.cliente,
    DiasRecorrencia: values.diasRecorrencia ? parseInt(values.diasRecorrencia) : '0',
    RecorrenciaLigada: values.recorrenciaLigada || false,
    ValorIndividualPallet: values.valorIndividualPallet || '0',
    ValorEtiquetas: values.valorEtiquetas || '0',
    ValorArmazenagem: values.valorArmazenagem || '0',
    Freetime: values.freetime ? parseInt(values.freetime) : '0',
    DataVigencia: values.dataVigencia || null
  };
};
export const mapFormToUpdateApi = values => {
  return {
    DiasRecorrencia: values.diasRecorrencia ? parseInt(values.diasRecorrencia) : '0',
    RecorrenciaLigada: values.recorrenciaLigada || false,
    ValorIndividualPallet: values.valorIndividualPallet || '0',
    ValorEtiquetas: values.valorEtiquetas || '0',
    ValorArmazenagem: values.valorArmazenagem || '0',
    Freetime: values.freetime ? parseInt(values.freetime) : '0',
    DataVigencia: values.dataVigencia || null
  };
};
export const mapClienteToFormValues = cliente => {
  return {
    diasRecorrencia: cliente.DiasRecorrencia?.toString() || '',
    recorrenciaLigada: cliente.RecorrenciaLigada || false,
    valorIndividualPallet: cliente.ValorIndividualPallet || '',
    valorEtiquetas: cliente.ValorEtiquetas || '',
    valorArmazenagem: cliente.ValorArmazenagem || '',
    freetime: cliente.Freetime?.toString() || '',
    dataVigencia: cliente.DataVigencia || ''
  };
};
